module.exports = __webpack_public_path__ + "img/media_de_itens_na_cesta.e53b6c1e.png";